import React from 'react';
import { Textarea } from '@brighterion/br-ui';
import { Field, FieldHookConfig, FieldProps } from 'formik';

type Props = Pick<
    React.ComponentProps<typeof Textarea>,
    'maxChar' | 'label' | 'id' | 'dataTestId' | 'showCounter' | 'lineNum' | 'error' | 'errorMsg'
> &
    FieldHookConfig<string>;

export function FormikFieldTextArea({
    name,
    label,
    id = label,
    showCounter = false,
    dataTestId,
    maxChar = 5000,
    disabled,
    lineNum = 5,
    className
}: Props) {
    return (
        <Field name={name}>
            {({ field, form: { errors, touched } }: FieldProps) => (
                <Textarea
                    dataTestId={dataTestId}
                    className={className}
                    showCounter={showCounter}
                    id={id}
                    label={label}
                    maxChar={maxChar}
                    disabled={disabled}
                    lineNum={lineNum}
                    error={!!(errors[field.name] && touched[field.name])}
                    errorMsg={errors[field.name]?.toString()}
                    allowPan
                    {...field}
                />
            )}
        </Field>
    );
}
